import { render, staticRenderFns } from "./PlanetaryTracks.vue?vue&type=template&id=48393d5a&"
import script from "./PlanetaryTracks.vue?vue&type=script&lang=ts&"
export * from "./PlanetaryTracks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports